/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_Select_NoneInputs */

const en_recipes_select_none = /** @type {(inputs: Recipes_Select_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select none`)
};

const de_recipes_select_none = /** @type {(inputs: Recipes_Select_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine auswählen`)
};

/**
* | output |
* | --- |
* | "Select none" |
*
* @param {Recipes_Select_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_select_none = /** @type {((inputs?: Recipes_Select_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Select_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_select_none(inputs)
	return en_recipes_select_none(inputs)
});